import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-case-studies',
    imports: [],
    templateUrl: './case-studies.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './case-studies.component.scss'
})
export class CaseStudiesComponent {

}
